/* PYS UX quick wins (added 2026-10-05): PDP photo counter + size-guide image loads only when opened. */
(function () {
  /* ---- PDP gallery photo counter: "1 / 5" ---- */
  if (window.customElements && !customElements.get('pys-gallery-count')) {
    customElements.define('pys-gallery-count', class extends HTMLElement {
      connectedCallback() {
        var self = this, tries = 0;
        var gallery = this.closest('media-gallery');
        var cur = this.querySelector('[data-pys-count-current]');
        if (!gallery || !cur) return;
        (function wait() {
          var s = gallery.sliderInstance && gallery.sliderInstance.slider;
          if (s && typeof s.on === 'function') {
            var update = function () {
              var i = typeof s.realIndex === 'number' ? s.realIndex : 0;
              cur.textContent = String(i + 1);
            };
            s.on('slideChange', update);
            s.on('realIndexChange', update);
            update();
            self.classList.add('is-ready');
          } else if (tries++ < 150 && self.isConnected) {
            setTimeout(wait, 100);
          }
        })();
      }
    });
  }

  /* ---- Size guide: image inside the size chart modal only downloads when the modal opens ---- */
  function loadSizeGuide(scope) {
    (scope || document).querySelectorAll('img[data-pys-src]').forEach(function (img) {
      var src = img.getAttribute('data-pys-src');
      if (/cdn\.shopify\.com|\/cdn\/shop\//.test(src) && !/[?&]width=/.test(src)) src += (src.indexOf('?') === -1 ? '?' : '&') + 'width=1600';
      img.src = src;
      img.removeAttribute('data-pys-src');
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.open-size-chart, [aria-controls*="SizeChart"]');
    if (!t) return;
    var id = t.getAttribute('aria-controls');
    var modal = id && document.getElementById(id);
    loadSizeGuide(modal || document);
  }, true);
  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      records.forEach(function (r) {
        var el = r.target;
        if (el.hasAttribute && el.hasAttribute('open') && el.classList && el.classList.contains('pys-size-chart-modal')) loadSizeGuide(el);
      });
    }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['open'] });
  }
})();
